// Carrusel de videos bajo las reseñas del producto. SIN autoplay a
// propósito (varios celulares reales reaccionaban al autoplay moviendo
// la página sola): el video solo se precarga cuando está cerca de la
// pantalla, y arranca únicamente cuando el usuario toca el botón de
// play. Siempre muteado por si el usuario lo deja sonando de fondo.
(function () {
  var carruseles = document.querySelectorAll('[data-tz-video-carrusel]');
  if (!carruseles.length) return;

  function ocultarBoton(slide) {
    var boton = slide.querySelector('[data-tz-video-resenas-play]');
    if (boton) boton.hidden = true;
  }
  function mostrarBoton(slide) {
    var boton = slide.querySelector('[data-tz-video-resenas-play]');
    if (boton) boton.hidden = false;
  }

  function reproducir(video) {
    var promesa = video.play();
    if (promesa && typeof promesa.then === 'function') {
      promesa
        .then(function () {
          var slide = video.closest('[data-tz-video-slide]');
          if (slide) ocultarBoton(slide);
        })
        .catch(function () {});
    }
  }

  // Solo precarga (src + load): nunca llama a play() por su cuenta.
  function precargar(video) {
    if (video.dataset.tzCargado) return;
    video.dataset.tzCargado = 'true';
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.src = video.dataset.src;
    video.load();
  }

  carruseles.forEach(function (carrusel) {
    var contenedor = carrusel.closest('[data-tz-video-resenas]');
    var slides = Array.prototype.slice.call(carrusel.querySelectorAll('[data-tz-video-slide]'));
    var puntosWrap = contenedor.querySelector('[data-tz-video-puntos]');
    var puntos = puntosWrap ? Array.prototype.slice.call(puntosWrap.querySelectorAll('[data-tz-video-punto]')) : [];
    var btnPrev = carrusel.querySelector('[data-tz-video-prev]');
    var btnNext = carrusel.querySelector('[data-tz-video-next]');
    var activo = 0;

    function videoDe(slide) { return slide.querySelector('.tz-video-resenas__video'); }

    function activarSlide(indice) {
      if (indice < 0) indice = slides.length - 1;
      if (indice >= slides.length) indice = 0;
      if (indice === activo && slides[indice].classList.contains('is-activa')) return;

      var slideAnterior = slides[activo];
      var videoAnterior = videoDe(slideAnterior);
      if (videoAnterior && !videoAnterior.paused) videoAnterior.pause();
      slideAnterior.classList.remove('is-activa');

      activo = indice;
      var slideNueva = slides[activo];
      slideNueva.classList.add('is-activa');
      puntos.forEach(function (p, i) {
        p.classList.toggle('is-activo', i === activo);
      });

      // Precarga la nueva pero NO la reproduce sola — el usuario decide.
      precargar(videoDe(slideNueva));
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { activarSlide(activo - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { activarSlide(activo + 1); });
    puntos.forEach(function (p) {
      p.addEventListener('click', function () {
        activarSlide(parseInt(p.getAttribute('data-indice'), 10) || 0);
      });
    });

    // Deslizar con el dedo para cambiar de video.
    var tocadoX = null;
    carrusel.addEventListener('touchstart', function (evento) {
      tocadoX = evento.touches[0].clientX;
    }, { passive: true });
    carrusel.addEventListener('touchend', function (evento) {
      if (tocadoX === null) return;
      var deltaX = evento.changedTouches[0].clientX - tocadoX;
      tocadoX = null;
      if (Math.abs(deltaX) < 40) return;
      if (deltaX < 0) activarSlide(activo + 1);
      else activarSlide(activo - 1);
    }, { passive: true });

    // Único disparador real de reproducción: el botón de play, a propósito.
    carrusel.addEventListener('click', function (evento) {
      var boton = evento.target.closest('[data-tz-video-resenas-play]');
      if (!boton) return;
      var slide = boton.closest('[data-tz-video-slide]');
      var video = slide && videoDe(slide);
      if (!video) return;
      precargar(video);
      reproducir(video);
    });

    // Si el navegador pausa el video por su cuenta (pestaña en segundo
    // plano, etc.), vuelve a aparecer el botón en vez de quedar "muerto".
    carrusel.addEventListener('pause', function (evento) {
      var video = evento.target;
      if (!video.classList || !video.classList.contains('tz-video-resenas__video')) return;
      if (video.ended) return;
      var slide = video.closest('[data-tz-video-slide]');
      if (slide) mostrarBoton(slide);
    }, true);

    // Precarga (nunca reproduce) el slide activo apenas se acerca a la
    // pantalla, para que arranque rápido en cuanto el usuario lo pida.
    function estaCercaDeLaPantalla(el) {
      var r = el.getBoundingClientRect();
      var margen = 200;
      return r.bottom > -margen && r.top < (window.innerHeight || document.documentElement.clientHeight) + margen;
    }
    function revisarManualmente() {
      var videoActivo = videoDe(slides[activo]);
      if (!videoActivo || videoActivo.dataset.tzCargado) return;
      if (estaCercaDeLaPantalla(contenedor)) precargar(videoActivo);
    }
    var tzScrollTick = false;
    function alHacerScrollOResize() {
      if (tzScrollTick) return;
      tzScrollTick = true;
      requestAnimationFrame(function () {
        revisarManualmente();
        tzScrollTick = false;
      });
    }
    window.addEventListener('scroll', alHacerScrollOResize, { passive: true });
    window.addEventListener('resize', alHacerScrollOResize);
    revisarManualmente();
    setTimeout(revisarManualmente, 1500);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            precargar(videoDe(slides[activo]));
          } else {
            var videoVisible = videoDe(slides[activo]);
            if (videoVisible && !videoVisible.paused) videoVisible.pause();
          }
        });
      }, { threshold: 0.25, rootMargin: '200px 0px' });
      observer.observe(contenedor);
    }
  });
})();
